// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiImportSyncsConnectionResult = objectOf({
  data_preview: arrayOf(
    objectOf({
      PAYLOAD: maybe(string),
      EXTERNAL_ID: maybe(string),
      ALIAS_NAME: maybe(string),
      ALIAS_LABEL: maybe(string),
      BRAZE_ID: maybe(string),
    })
  ),
  error: maybe(string),
  status: string,
});
